(function () {
  'use strict';

  angular
    .module('directive.steps', [])

    /* @ngInject */
    .directive('stepsCart', function () {
      return {
        restrict: 'E',
        bindToController: {
          data: '<steps'
        },
        controllerAs: 'stepsCartCtrl',
        /* @ngInject */
        controller: ["RoutesService", "CartService", function (RoutesService, CartService) {
          var ctrl = this;

          CartService.setStepsCartCtrl(ctrl);

          ctrl.$onInit = function () {
            ctrl.steps = _.cloneDeep(ctrl.data);
          };

          ctrl.update = function (current) {
            var _routes = RoutesService.get();
            ctrl.current = current;
            _.each(ctrl.steps, function (step, i) {
              step.index = i + 1;
              step.hide = step.hide || false;
              switch (i) {
              case 0:
                step.link = '/' + _routes.Cart.url;
                break;
              case 2:
                step.link = '/' + _routes.CartShipping.url;
                break;
              case 3:
                step.link = '/' + _routes.CartPayment.url;
                break;
              case 4:
                step.link = '/' + _routes.CartValidation.url;
                break;
                // no default
              }
              step.class = 'active';
              if (step.index < current) step.class = 'active step-success';
              if (step.index === current) step.class = 'active step-active step-success';
            });
            ctrl.stepsActive = _.each(_.filter(ctrl.steps, {'hide': false}), function (step, i) {
              step.n = i + 1;
            });
            ctrl.stepStyle = { 'width': (100 / ctrl.stepsActive.length) + '%' };
            ctrl.init = true;
          };

        }]
      };
    });

})();
